import { Messages } from '../../../codegen/Localize';
import { Order } from '../../helpers/Order';
import { OrderKeys } from '../OrderKeys';
import { SortOptions } from './CommonSortOptions';
import { OptionsDictionary } from './SortOptionDefinitions';

export const metricsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'modified': SortOptions.updated,
  'metricValue': {
    id: 'metricValue',
    getMenuItemDisplayValue: Messages.metricValue,
    subSortOptions: {
      'desc': {
        id: 'metricValue.desc',
        field: OrderKeys.metricValue,
        getMenuItemDisplayValue: Messages.sortByLargeSmall,
        getButtonDisplayValue: Messages.sortByMetricValueDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.metricValue)]
      },
      'asc': {
        id: 'metricValue.asc',
        field: OrderKeys.metricValue,
        getMenuItemDisplayValue: Messages.sortBySmallLarge,
        getButtonDisplayValue: Messages.sortByMetricValueASC,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.metricValue)]
      }
    }
  },
  'metricViewName': {
    id: 'metricViewName',
    getMenuItemDisplayValue: Messages.column_metrics_viewName,
    subSortOptions: {
      'asc': {
        id: 'metricViewName.asc',
        field: OrderKeys.metricViewName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByViewAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.metricViewName)]
      },
      'desc': {
        id: 'metricViewName.desc',
        field: OrderKeys.metricViewName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByViewDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.metricViewName)]
      }
    }
  },
  'owner': {
    id: 'owner',
    getMenuItemDisplayValue: Messages.column_owner,
    subSortOptions: {
      'asc': {
        id: 'owner.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOwnerAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.ownerName)]
      },
      'desc': {
        id: 'owner.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOwnerDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.ownerName)]
      }
    }
  },
  'metricUpdated': {
    id: 'metricUpdated',
    getMenuItemDisplayValue: Messages.column_metrics_lastUpdated,
    subSortOptions: {
      'asc': {
        id: 'metricUpdated.asc',
        field: OrderKeys.metricUpdated,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByLastUpdatedAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.metricUpdated)]
      },
      'desc': {
        id: 'metricUpdated.desc',
        field: OrderKeys.metricUpdated,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByLastUpdatedDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.metricUpdated)]
      }
    }
  }
};
